export const initMenu = () => {
    // VARS
    const hamburgerButton = document.querySelector('[data-hamburger]');
    const menu = document.querySelector('.main-header__nav');
    const menuOverlay = document.querySelector('.main-header__overlay');
  
    const searchBtn = document.querySelector('[data-search-btn]');
    const search = document.querySelector('[data-search]');
    const closeSearchBtn = document.querySelector('[data-close-search]');
    const mmSubItems = document.querySelectorAll("li.mm-sub[data-sub-menu]");
  
    // LISTENERS
  
    const icon = hamburgerButton.querySelector('path');
  
    hamburgerButton.addEventListener('click', function () {
       menu.classList.toggle('show');
    //    menuOverlay.classList.add('active');
        menuOverlay.classList.toggle('active');
       hamburgerButton.classList.toggle('active');
    });
  
    searchBtn.addEventListener('click', function () {
        search.classList.add('show');
    });
  
    closeSearchBtn.addEventListener('click', function () {
        search.classList.remove('show');
        // menuOverlay.classList.remove('active');
        menuOverlay.classList.toggle('active');
    });
  
    const headerMenu = document.querySelector('[data-header-menu]');
    const menuItems = headerMenu.querySelectorAll('li');
  
    menuItems.forEach((item) => {
        const submenu = item.querySelector('ul');
  
        if (submenu) {
            item.addEventListener('click', function (event) {
                event.preventDefault();
  
                const isOpen = item.classList.contains('submenuOpen');
  
                // Скрываем все открытые списки перед открытием текущего
                menuItems.forEach((otherItem) => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('submenuOpen');
                    }
                });
  
                if (!isOpen) {
                    item.classList.add('submenuOpen');
                }
            });
        }
    });
  
    document.addEventListener('click', function (event) {
        // Проверяем, что клик был сделан вне меню
        if (!event.target.closest('[data-header-menu]')) {
            // Скрываем все открытые списки
            menuItems.forEach((item) => {
                item.classList.remove('submenuOpen');
            });
        }
    });


    mmSubItems.forEach(item => {
        item.addEventListener("click", () => {
        const ul = item.querySelector("ul");
        if (ul.style.display === "block") {
            ul.style.display = "none";
        } else {
            ul.style.display = "block";
        }
        });
    });
  }